import { render, staticRenderFns } from "./show-img.vue?vue&type=template&id=70dfe47d"
import script from "./show-img.vue?vue&type=script&lang=ts"
export * from "./show-img.vue?vue&type=script&lang=ts"
import style0 from "./show-img.vue?vue&type=style&index=0&id=70dfe47d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports